import mapReducer from "./reducers";
export default mapReducer;
